/* Kingdomland — shared behaviour for the sub-pages (shows, books & games, pricing).
 *
 * Two jobs, both decoration:
 *   1. Header frost-on-scroll, matching the homepage. The homepage does this from
 *      its hero bootstrap, which obviously never runs on other pages — so the bar
 *      stayed solid white from the top here. Same class, same threshold.
 *   2. Pointer tilt on cards inside a [data-kdl-tilt] container.
 *
 * Both are skipped entirely under prefers-reduced-motion, and nothing here is
 * required for the page to be usable or navigable.
 */
(function () {
  var reduced = false;
  try { reduced = matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  /* ---------------------------------------------------------- header frosting */
  (function () {
    var grp = document.querySelector('.shopify-section-group-header-group');
    if (!grp) return;

    // The header is a fixed overlay, so it occupies no flow space. Publish its
    // measured height for the page heroes to pad against — the stylesheet's
    // --header-h is the reference site's 66px, not what this store renders.
    function publishHeight() {
      var h = Math.round(grp.getBoundingClientRect().height);
      if (h) document.documentElement.style.setProperty('--kdl-header-h', h + 'px');
    }
    publishHeight();
    addEventListener('resize', publishHeight, { passive: true });

    var on = false;
    function sync() {
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      var next = y > 12;
      if (next !== on) { on = next; grp.classList.toggle('kdl-hdr-scrolled', on); }
    }
    sync();
    addEventListener('scroll', sync, { passive: true });
  }());

  /* ------------------------------------------------------------- pointer tilt */
  if (reduced) return;

  var MAX = 7; // degrees — subtle enough to read as depth, not as a gimmick

  function bind(card) {
    if (card.__kdlTilt) return;
    card.__kdlTilt = true;
    var raf = 0, rx = 0, ry = 0;

    function apply() {
      raf = 0;
      card.style.setProperty('--rx', rx.toFixed(2) + 'deg');
      card.style.setProperty('--ry', ry.toFixed(2) + 'deg');
    }
    function move(e) {
      var r = card.getBoundingClientRect();
      if (!r.width || !r.height) return;
      var px = (e.clientX - r.left) / r.width - 0.5;
      var py = (e.clientY - r.top) / r.height - 0.5;
      ry = px * MAX * 2;
      rx = -py * MAX * 2;
      // .frame-shine tracks the pointer as a soft highlight; harmless when absent
      card.style.setProperty('--mx', ((px + 0.5) * 100).toFixed(1) + '%');
      card.style.setProperty('--my', ((py + 0.5) * 100).toFixed(1) + '%');
      if (!raf) raf = requestAnimationFrame(apply);
    }
    function reset() {
      rx = 0; ry = 0;
      if (!raf) raf = requestAnimationFrame(apply);
    }

    card.addEventListener('pointermove', move);
    card.addEventListener('pointerleave', reset);
    card.addEventListener('blur', reset, true);
  }

  function scan() {
    var hosts = document.querySelectorAll('[data-kdl-tilt]');
    for (var i = 0; i < hosts.length; i++) {
      var cards = hosts[i].querySelectorAll('.tilt');
      for (var j = 0; j < cards.length; j++) bind(cards[j]);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  // Shopify's theme editor re-renders sections in place
  document.addEventListener('shopify:section:load', scan);
}());
